import {WIDGET_TYPE, getLocale} from '@wix/wix-events-commons-statics'
import {SET_BASE_ENVIRONMENT} from '../../commons/actions/environment'
import {updateDates} from '../../commons/actions/dates'
import {INJECT_COMPONENT_DRAFT} from '../actions/component'
import {LOAD_EVENTS} from '../actions/event'
import {getRealEvents, hasRealEvents} from '../selectors/events'
import {State} from '../types/state'

export const datesMiddleware = store => next => action => {
  switch (action.type) {
    case SET_BASE_ENVIRONMENT: {
      const state: State = store.getState()
      const eventsList = hasRealEvents(state) ? getRealEvents(state) : getAllDemoEvents(state)
      const locale = getLocale(action.payload.locale)
      store.dispatch(updateDates({eventsList, locale}))
      break
    }
    case INJECT_COMPONENT_DRAFT: {
      store.dispatch(updateDates({eventsList: action.payload.component.events}))
      break
    }
    case LOAD_EVENTS.SUCCESS: {
      store.dispatch(updateDates({eventsList: action.payload.events}))
      break
    }
    default:
      break
  }
  next(action)
}

const getAllDemoEvents = (state: State) => {
  return [...(state.demoEvents?.[WIDGET_TYPE.LIST] ?? []), ...(state.demoEvents?.[WIDGET_TYPE.SINGLE] ?? [])]
}
